export default __webpack_public_path__ + "static/media/homepage-vision-mission.7955dc3a.png";